import React, { ReactElement } from 'react'
import TextInput from '../formGroup/TextInput'
import SearchSelect from '../formGroup/SearchSelect'
import AsyncSearchSelect from '../formGroup/AsyncSearchSelect'
import { IAddressSection } from '../../interfaces/Step4'
import { DefaultJddAddress } from '../../store/State/JddAddress'
import useAddressSectionHook from '../../hooks/useAddressSectionHook'
import { FRENCH_COLONIES } from '../../enums/Countries'
import Spinner from '../Spinner'
import { STATUS } from '../../enums/common'

function AddressSection({
  register,
  errors,
  control,
  triggerValidation,
  setValue,
  watch,
  setError,
  clearError,
}: IAddressSection): ReactElement {
  const {
    jddAddress,
    handleOnChangeCountry,
    handleOnChangeCity,
    addressCountry,
    addressCity,
    cities,
    citiesStatus,
    getAddressVille,
    countriesStatus,
    residentialCountriesList,
  } = useAddressSectionHook({ setValue, watch, setError, clearError })
  const {
    adresse_batiment,
    adresse_rue,
    adresse_bp,
    adresse_cp,
    adresse_ville,
  } = jddAddress || DefaultJddAddress

  return (
    <div className="card cardContent mb2 mb0md pt4 pb4 pb6lg cardSmContent mt4">
      <div className="row">
        <div className="colLg12 mb15 px4 px15lg">
          <p>
            Toute ou partie de votre adresse a été récupérée et enregistrée dans
            le formulaire ci-dessous.
          </p>
          <p>
            Merci de valider ou éventuellement compléter les données présentées
            avant de poursuivre.
          </p>
        </div>
        <TextInput
          id="adresse_rue"
          name="adresse_rue"
          register={register({ required: true })}
          error={errors.adresse_rue}
          defaultValue={adresse_rue}
          label="Numéro et voie"
          placeHolder="Exemple : 10 rue Saint Antoine"
          className="col12 colLg6 mb15 px4 pl15lg pr3lg"
          inputClassName="inputFieldSecondary"
          required
          triggerValidation={triggerValidation}
        />
        <TextInput
          id="adresse_batiment"
          name="adresse_batiment"
          register={register}
          error={errors.adresse_batiment}
          defaultValue={adresse_batiment}
          label="Résidence / Bâtiment"
          placeHolder="Exemple : Résidence Les Lilas"
          className="col12 colLg6 mb15 px4 pr15lg pl3lg"
          inputClassName="inputFieldSecondary"
          triggerValidation={triggerValidation}
        />
        <TextInput
          id="adresse_bp"
          name="adresse_bp"
          register={register}
          error={errors.adresse_bp}
          defaultValue={adresse_bp}
          label="BP / Lieu-dit"
          placeHolder="Exemple : Les chemins du hautbois"
          className="col12 colLg6 mb15 px4 pl15lg pr3lg"
          inputClassName="inputFieldSecondary"
          triggerValidation={triggerValidation}
        />
        <SearchSelect
          id="adresse_pays"
          name="adresse_pays"
          label="Pays"
          placeHolder="Sélectionner"
          options={residentialCountriesList}
          value={addressCountry}
          control={control}
          rules={{
            required: true,
          }}
          required
          register={register}
          error={errors.adresse_pays}
          onChange={handleOnChangeCountry}
          className="col12 colLg6 mb15 px4 pr15lg pl3lg"
        />
        {countriesStatus !== STATUS.loaded && (
          <div className="col12 colLg6 mb15 px4 px15lg mt25">
            <Spinner small={true} />
          </div>
        )}
        {addressCountry && addressCountry.value && (
          <>
            {FRENCH_COLONIES.includes(addressCountry.value) && (
              <div className="colLg6 pr3lg">
                <div className="row">
                  <TextInput
                    id="adresse_cp"
                    name="adresse_cp"
                    register={register({ required: true })}
                    error={errors.adresse_cp}
                    defaultValue={adresse_cp}
                    label="Code Postal"
                    placeHolder="Votre texte ici..."
                    className="col12 colLg6 mb15 px4 px15lg"
                    inputClassName="inputFieldSecondary"
                    required
                    triggerValidation={triggerValidation}
                  />
                  <input
                    type="hidden"
                    name="adresse_ville"
                    value={getAddressVille()}
                    ref={register()}
                  />
                  <AsyncSearchSelect
                    id="commune_habitation"
                    name="commune_habitation"
                    label="Commune d’habitation / Ville"
                    required
                    placeHolder="Sélectionner"
                    className={`col12 colLg6 mb15 px4 px15lg ${
                      errors.commune_habitation ? 'inputSelectError' : ''
                    } ${
                      citiesStatus === STATUS.pending && !cities ? 'hidden' : ''
                    }`}
                    options={cities}
                    value={addressCity}
                    control={control}
                    rules={{
                      required: true,
                      validate: (option) => {
                        const postalCode = watch('adresse_cp')
                        if (postalCode && option.postalCode !== postalCode) {
                          return 'Le Code Postal et la Commune Habitation ne correspondent pas'
                        }

                        return true
                      },
                    }}
                    register={register}
                    error={errors.commune_habitation}
                    onChange={handleOnChangeCity}
                    inputSearchExpression={/[^a-zA-Z0-9_-]/g}
                    postalCode={watch('adresse_cp')}
                  />
                  {citiesStatus === STATUS.pending && !cities && (
                    <div className="col12 colLg6 mb15 px4 px15lg mt25">
                      <Spinner small={true} />
                    </div>
                  )}
                </div>
              </div>
            )}
            {!FRENCH_COLONIES.includes(addressCountry.value) && (
              <TextInput
                id="adresse_ville"
                name="adresse_ville"
                register={register({ required: true })}
                error={errors.adresse_ville}
                defaultValue={adresse_ville}
                label="Commune d’habitation / Ville"
                placeHolder="Votre texte ici..."
                className="col12 colLg6 mb15 px4 pl15lg pr3lg"
                inputClassName="inputFieldSecondary"
                required
                triggerValidation={triggerValidation}
              />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default AddressSection
